module.exports = __webpack_public_path__ + "img/mobile-tick.3af673d1.svg";